import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";

export default function useGetSingleCompany() {
  return useQuery({
    queryKey: ["company"],
    queryFn: async () => {
      const response = await axiosGet("/users/getSingleCompany");
      return response.data.data.company;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}

// async function getCompany() {
//     try {
//         const response = await axiosGet("/users/getSingleCompany");
//         const { company } = response.data.data;
//         setBranding(
//             environment().isAI
//                 ? company?.ai_addons?.branding
//                 : company?.omniaddons?.branding,
//         );
//     } catch (err) { }
// }
